module.exports = __webpack_public_path__ + "static/media/eco.2965152e.webp";